import api from './api';

export interface Product {
  id: number;
  name: string;
  price: number;
}

export interface OrderItem {
  id: number;
  productId: number;
  quantity: number;
  price: number;
  Product: Product;
}

export interface Order {
  id: number;
  customerId: number;
  totalAmount: number | string;
  status: 'pending' | 'processing' | 'shipped' | 'delivered' | 'cancelled';
  shippingAddress: string;
  created_at: string;
  updated_at: string;
  OrderItems: OrderItem[];
}

export const orderService = {
  getMyOrders: async (): Promise<Order[]> => {
    const response = await api.get('/orders/my-orders');
    return response.data;
  },

  getOrderById: async (orderId: number): Promise<Order> => {
    const response = await api.get(`/orders/${orderId}`);
    return response.data;
  },

  cancelOrder: async (orderId: number): Promise<void> => {
    await api.put(`/orders/my-orders/${orderId}/status`, { status: 'cancelled' });
  },
};
